import { HS_NAV_BEFORE_CONTAINER_ID, GROWTH_DYNAMIC_UI_ID, NOTIFICATIONS_BANNER_IFRAME_ID, ONBOARDING_TOURS_BANNER_ID, TRIAL_BANNER_ID } from '../constants';
export function getContainersAboveNav() {
  const navBeforeContainer = document.getElementById(HS_NAV_BEFORE_CONTAINER_ID);
  const growthDynamicContainer = document.getElementById(GROWTH_DYNAMIC_UI_ID);
  const trialBannerContainer = document.getElementById(TRIAL_BANNER_ID);
  const notificationsBannerContainer = document.getElementById(NOTIFICATIONS_BANNER_IFRAME_ID);
  const onboardingToursBannerContainer = document.getElementById(ONBOARDING_TOURS_BANNER_ID);
  return {
    [HS_NAV_BEFORE_CONTAINER_ID]: navBeforeContainer,
    [GROWTH_DYNAMIC_UI_ID]: growthDynamicContainer,
    [NOTIFICATIONS_BANNER_IFRAME_ID]: notificationsBannerContainer,
    [ONBOARDING_TOURS_BANNER_ID]: onboardingToursBannerContainer,
    [TRIAL_BANNER_ID]: trialBannerContainer
  };
}